import { getChainSymbol } from '@passkeys/assets';
import Icon from '@passkeys/ui/icon';
import TextField from '@passkeys/ui/text-field';

import Filter from '@/ui/components/filter';
import useEnabledAssets from '@/ui/hooks/use-enabled-assets';
import showFilterChainsModal from '@/ui/modals/filter-chains-modal';
import { isAllOption } from '@/ui/utils/content';
import type { ChainNameSelection } from '../types.js';

export interface FiltersProps {
  chains: string[];
  selectedChains: ChainNameSelection;
  onSelectedChainsChange: (selectedChain: ChainNameSelection) => void;
  query: string;
  onQueryChange: (value: string) => void;
}

function Filters({
  chains,
  selectedChains,
  onSelectedChainsChange,
  query,
  onQueryChange,
}: FiltersProps) {
  const allChains = isAllOption(selectedChains);
  const assets = useEnabledAssets();

  const handleChainFilterClick = async () => {
    const chainAssets = chains.map((name) => assets[name]);
    const selectedChainAssets = allChains
      ? []
      : selectedChains.map((chainName) => assets[chainName]);

    const { result } = await showFilterChainsModal({
      options: chainAssets,
      defaultSelected: selectedChainAssets,
    });
    if (result) {
      onSelectedChainsChange(
        isAllOption(result) ? result : result.map((chain) => chain.name),
      );
    }
  };

  return (
    <div className="mb-2 grid w-full grid-cols-2 gap-2">
      <TextField
        prefix={
          <Icon
            className="text-gray-400 theme-dark:text-neutral-200"
            name="magnifying-glass"
            size={24}
          />
        }
        onChange={onQueryChange}
        placeholder="Search"
        dataTestId="filter-search-input"
        value={query}
      />
      <Filter
        dataTestId="filter-chains-button"
        onClick={handleChainFilterClick}
        value={
          allChains
            ? 'All chains'
            : selectedChains
                .map((chainName) => getChainSymbol(assets[chainName]))
                .join(', ')
        }
      />
    </div>
  );
}

export default Filters;
